<template>
  <div class="xxxx" name="nnn">
    近期有诈骗份子冒充暗签平台skype账号进行诈骗。我们不会泄露客户信息，也不会随意去添加客户。请认准官方唯一指定账户skype：1052500005. 纸飞机：@ios6868.
  </div>
</template>

<script>
export default {
  name: "staticNotice"
}
</script>

<style scoped>
.xxxx {
  height: 40px;
  background: red;
  color: white;
  text-align: center;
  width: 100%;
  line-height: 40px;
}
</style>
